import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { exportList } from '@/api/common'
import { DcMessage } from '@dc-platform/dc-components'
import { useI18n } from 'vue-i18n'

const __default__ = {
  name: 'ExportBtn'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  text: {
    type: String,
    default: '导出'
  },
  search: {
    type: Object,
    default: () => {
      return {}
    }
  },
  totalCount: {
    type: Number,
    default: 0
  },
  appId: {
    type: String
  },
  taskType: {
    type: String
  }
},
  setup(__props) {

const { t } = useI18n()
const loading = ref(false)
const props = __props
const exportFile = () => {
  if (props.totalCount > 15000) {
    DcMessage.warning('请一次导出1万5千条以下数据')
    return
  }
  loading.value = true
  const { pageNumber, pageSize, ...other } = props.search
  exportList({
    appId: props.appId,
    taskType: props.taskType,
    query: other
  })
    .then((res) => {
      DcMessage.success(t('tips.exportSuccess'))
    })
    .finally(() => {
      loading.value = false
    })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_component_a_button, _mergeProps(_ctx.$attrs, {
    onClick: exportFile,
    loading: loading.value
  }), {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('btn.export')), 1)
    ]),
    _: 1
  }, 16, ["loading"]))
}
}

})